import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { UserReview, StoreItem } from "../../types/types";

let initialState:StoreItem<UserReview[]>={
    requestStatus:"not_initiated",
    responseStatus:"not_recieved",
    haveAnIssue:false,
    issue:"",
    data:[]
}

export const reviewsSlice=createSlice({
    name:'reviews',
    initialState:initialState,
    reducers:{
        initReviews:(state,action:PayloadAction<StoreItem<UserReview[]>>)=>({...action.payload}),
        addReviews:(state,action:PayloadAction<UserReview>)=>{state.data.push(action.payload)},
        updateReviews:(state,action:PayloadAction<UserReview>)=>{
            let index=state.data.findIndex((item:any)=>item._id===action.payload._id);
            state.data[index]=action.payload;
        },
        removeReviews:(state,action:PayloadAction<string>)=>{state.data=state.data.filter((item:any)=>item._id!==action.payload)},
        resetReviews:(state,action:PayloadAction)=>({...initialState})

    }
})

export const {initReviews,addReviews,removeReviews,updateReviews,resetReviews}=reviewsSlice.actions;
export default reviewsSlice.reducer;